import React, {Component} from 'react';
import { Link } from "react-router";
import PropTypes from 'prop-types';
import { database } from '../firebase';
import ms from '../ms';
import YorumForm2 from './YorumForm2';

class Yorum extends Component {
    constructor(props) {
      super(props);
      this.database = database.ref(`users`);
      this.database2 = database.ref(`yorumlar/${window.location.pathname.slice(2)}/${props.commentId}/yorumlar`);
      this.commentAuthor = props.commentAuthor;
      this.commentContent = props.commentContent;
      this.commentDate = props.commentDate;
      this.commentId = props.commentId;
      this.state = {
        asdf: [],
        asdf2: [],
        acik: false,
        commentContent: this.props.commentContent // state'e ekledik
      }
      this.goster = this.goster.bind(this);
      this.baska = this.baska.bind(this);
    }

    componentDidMount() {
      var databeys = this.database2;
      this.database2.get().then(function(snap) {
        if (snap.val() === null) {
          databeys.push({
            commentDate: "x"
          })
        }
      });
      const previousComments = this.state.asdf;
      const previousComments2 = this.state.asdf2;
      this.database2.on('child_added', snap => {
        if (snap.val().commentDate == "x") { }
        else previousComments2.push(snap.val())
    
        this.setState({
          asdf2: previousComments2,
        })
      })
    
      this.database.on('child_added', snap => {
        previousComments.push({
          id: snap.key,
          name: snap.val().userName,
          image: snap.val().userImage,
          uid: snap.val().uid
        })
    
        this.setState({
          asdf: previousComments,
        })
      })
    
      this.database.on('child_removed', snap => {
        for (var i = 0; i < previousComments.length; i++) {
          if (previousComments[i].id === snap.key) {
            previousComments.splice(i, 1);
          }
        }
        this.setState({
          asdf: previousComments,
        })
      })
    
      if (this.state.asdf2.length < 2) {
        this.setState({ acik: false }); // Başlangıçta kapalı olarak ayarlıyoruz
        document.getElementById("b" + this.commentId).style.display = "none";
        document.getElementById("yorumform" + this.commentId).style.display = "block";
      } else {
        document.getElementById("b" + this.commentId).style.display = "block";
        this.setState({ acik: false })
      }
    
      // content-i içeriği state ile yönetiyoruz
      this.setState({ commentContent: this.props.commentContent });
    }    

    goster() {
      if (document.getElementById("asdf" + this.commentId).style.display == "none") {
        document.getElementById("asdf" + this.commentId).style.display = "block";
        if (this.state.asdf2.length < 1) document.getElementById("yorumform" + this.commentId).style.display = "block";
        if (this.state.asdf2.length > 0) {
          this.setState({
            acik: true
          });
        }
      } else if (document.getElementById("asdf" + this.commentId).style.display == "block") {
        document.getElementById("asdf" + this.commentId).style.display = "none";
        if (this.state.asdf2.length < 1) document.getElementById("yorumform" + this.commentId).style.display = "none";
        if (this.state.asdf2.length > 0) {
          this.setState({
            acik: false
          });
        }
      }
    }    

    baska() {

    }

    updateName(id) {
      var data = "";
      this.state.asdf.forEach(p => {
        if (p.uid !== id) return;
        else {
          database.ref(`users/${id}`).on('value', (snapshot) => {
            data = snapshot.val().userName;
          });
        }
      })
      return data;
    }

    updateImage(id) {
      var data = "";
      this.state.asdf.forEach(p => {
        if (p.uid !== id) return;
        else {
          database.ref(`users/${id}`).on('value', (snapshot) => {
            data = snapshot.val().userImage || "/default_user.jpg";
          });
        }
      })
      return data;
    }

    render() {
        return (
          <div className="yorum-card">
            <Link to={"/profil/"+this.props.commentAuthor} style={{display: "contents"}}><img src={this.updateImage(this.props.commentAuthor)} className="yorum-image"/></Link>
            <div style={{width: "100%"}}>
            <div style={{display: "flex"}}>
              <Link to={"/profil/"+this.props.commentAuthor}><div className="başlık">{this.updateName(this.props.commentAuthor)}</div></Link>
              <div className="yorum-date">{ms(Date.now() - this.props.commentDate, {long: true})+` önce`}</div>
            </div>
            {/* innerText yerine state kullanıyoruz */}
            <p className="yorum-icerik">{this.state.commentContent}</p>
            <div className="yorumlar">
            <b 
              style={this.state.asdf2.length > 0 ? { display: "block" } : { display: "none" }} 
              onClick={this.goster} 
              id={"b" + this.commentId}
            >
              {this.state.acik ? this.state.asdf2.length + " Yanıtı Gizle" : this.state.asdf2.length + " Yanıtı Görüntüle"}
            </b>
              <div id={"yorumform"+this.commentId} style={this.state.asdf2.length > 0 ? {display: "block"} : {display: "none"}}><YorumForm2 aydi={this.commentId} acik={this.state.acik}/></div>
              <div id={"asdf"+this.commentId} style={{display: "none", marginLeft: "-15px"}}>
                {this.state.asdf2.map((y) => {return (
                <div className="yorum-card2">
                  <Link to={"/profil/"+y.commentAuthor}><img src={this.updateImage(y.commentAuthor)} className="yorum-image"/></Link>
                  <div style={{width: "100%"}}>
                  <div style={{width: "100%", display: "flex"}}>
                    <Link to={"/profil/"+y.commentAuthor}><div className="başlık">{this.updateName(y.commentAuthor)}</div></Link>
                    <div className="yorum-date2">{ms(Date.now() - y.commentDate, {long: true})+` önce`}</div>
                  </div>
                  <p className="yorum-icerik">{y.commentContent}</p>
                  </div>
                </div>
                )})}
              </div>
            </div>
            </div>

            <style>{`
              .yorum-card {
                border-radius: 10px;
                margin: 10px 0px;
                padding: 0px;
                background: #ffffff;
                width: 100%;
                max-width: 100%;
                height: auto;
                display: flex;
              }

              .yorum-card2 {
                border-radius: 3px;
                padding: 0px;
                background: #ffffff;
                width: 100%;
                max-width: 100%;
                height: auto;
                display: flex;
              }
      
              .yorum-card img {
                position: relative;
                margin: 10px;
                border-radius: 50%;
                width: 40px;
                height: 40px;
                object-fit: cover;
              }
      
              .başlık {
                font-size: 13px;
                font-weight: bold;
                margin-top: 10px;
                text-align: left;
              }

              .yorum-icerik {
                color: #000;
                height: auto;
                text-align: left;
                font-size: 14px;
                font-weight: normal;
                padding-right: 30px;
                margin: 5px 0 0 0;
                line-height: 22px;
              }

              .yorumlar {
                width: 100%;
                color: #000;
                text-align: left;
                margin: 15px 0;
                display: block;
              }

              .yorumlar b {
                cursor: pointer;
              }
      
              .yorum-date {
                text-align: left;
                font-size: 13px;
                color: #606060;
                margin: 10px 0 0 10px;
                user-select: none;
              }

              .yorum-date2 {
                text-align: left;
                font-size: 13px;
                color: #606060;
                margin: 10px 0 0 10px;
                user-select: none;
              }
      
              @media (max-width: 623px) {
                .yorum-card {
                  width: 100%;
                  height: auto;
                  margin: 0;
                  padding-bottom: 10px;
                  box-shadow: 0 0;
                  border-radius: 0;
                }
              }
            `}</style>
         </div>
        )
    }
}

Yorum.propTypes = {
  commentAuthor: PropTypes.string,
  commentContent: PropTypes.string,
  commentDate: PropTypes.string,
  commentId: PropTypes.string,
}
export default Yorum;